module.exports = __webpack_public_path__ + "img/natudrin-depoimento-2.4fdc3eb2.jpg";